document.querySelectorAll('[data-honey-cart]').forEach(form => {
  const inputs = [...form.querySelectorAll('[data-honey-cart-quantity]')];
  const checkout = form.querySelector('[name="checkout"]');
  const error = form.querySelector('[data-honey-cart-error]');
  const check = () => {
    const count = inputs.reduce((sum, input) => sum + Number(input.value), 0);
    const invalid = inputs.some(input => !Number.isSafeInteger(Number(input.value)) || Number(input.value) < 0 || input.value === '');
    const over = count > Number(form.dataset.honeyMax);
    const paused = count > 0 && form.dataset.honeyOpen !== 'true';
    error.textContent = over ? form.dataset.honeyLimitMessage : paused ? form.dataset.honeyPausedMessage : '';
    checkout.disabled = invalid || over || paused;
    return !checkout.disabled;
  };
  inputs.forEach(input => input.addEventListener('input', check));
  form.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout' && !check()) event.preventDefault();
  });
  check();
});
